export default __webpack_public_path__ + "static/media/marauders-map-v3-05-01.572ccefb.jpg";